import styled, { css } from 'styled-components';
import TableRow from '@material-ui/core/TableRow';

export const CustomTableHeadRow = styled(TableRow)`
  height: auto !important;
  ${props =>
    props.clickable &&
    css`
      pointer-events: all;
    `};
  th {
    border-bottom: 1px solid #333d;
    &:last-child {
      padding-right: auto;
    }
  }
  .no-m {
    @media (max-width: 768px) {
      display: none;
    }
  }
  .no-l {
    @media (max-width: 1024px) {
      display: none;
    }
  }
`;
